import PlanImpressionPrixHelperController from './offre.impression.helper.controller';

export default {
    bindings: {
        modalInstance: '<'
    },
    template: require('./offre.impression.helper.html'),
    controller: PlanImpressionPrixHelperController
};
